$( document ).ready(function() {
  // $('.card-wrapper').matchHeight();
  $('.card--card').matchHeight();
  $('.card__information').matchHeight();

  var swiper = new Swiper(".custom-image-slider .mySwiper", {
    slidesPerView: 4,
    spaceBetween: 30,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2
      },
      480: {
        slidesPerView: 2
      },
      767: {
        slidesPerView: 3
      },
      990: {
        slidesPerView: 4
      }
    }
  });

  // let price_affirm = pr.split('.').join("");
  // if (price_affirm > 25000) {
  //   content += `<p class="affirm-as-low-as" data-page-type="product" data-amount="${price_affirm}"></p>`;
  //   //console.log("worked");
  // }
  // _affirm_config = {
  //    public_api_key:  "N2O478J05LTH982V",
  //    script:          "https://cdn1-sandbox.affirm.com/js/v2/affirm.js"
  // };
  // (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready");
  // // Use your live public API Key and https://cdn1.affirm.com/js/v2/affirm.js script to point to Affirm production environment.
  //   openQuickview(content);
  // }
  
});


function setupTabsAndMobileTabs() {
    const tabs = document.querySelectorAll('.tab');
    const mobileTabs = document.querySelectorAll('.mobile-tab-title');    
  
    if (window.innerWidth > 749) {
        const tabContents = document.querySelectorAll('.tab-content');
      
        tabContents.forEach(content => content.classList.remove('active'));
        tabs.forEach(t => t.classList.remove('active'));

        tabContents[0].classList.add('active');
        tabs[0].classList.add('active');

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                tabContents.forEach(content => content.classList.remove('active'));
                tabs.forEach(t => t.classList.remove('active'));

                tabContents[index].classList.add('active');
                tab.classList.add('active');
            });
        });
    } 
    else {
        mobileTabs.forEach(function (elm) {
            elm.addEventListener('click', function () {
                mobileTabs.forEach(function (otherElm) {
                    if (otherElm !== elm) {
                        otherElm.classList.remove('active');
                        otherElm.nextElementSibling.classList.remove('active');
                    }
                });
                elm.classList.toggle('active');
                elm.nextElementSibling.classList.toggle('active');
            });
        });
    } 
}

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelectorAll('.tab').length > 0 && document.querySelectorAll('.mobile-tab-title').length > 0 ){
    setupTabsAndMobileTabs(); 
  }
})

addEventListener("orientationchange",  function () { 
  if (document.querySelectorAll('.tab').length > 0  && document.querySelectorAll('.mobile-tab-title').length > 0 ){
    setupTabsAndMobileTabs();
  }
});

window.addEventListener('resize', function () {
   if (document.querySelectorAll('.tab').length > 0  && document.querySelectorAll('.mobile-tab-title').length > 0 ){
      setupTabsAndMobileTabs();
   }
});

$(".navMenus").on('click','li',function(){
  $(this).addClass("active");  // adding active class
});

// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelectorAll('.js-article-tag-filter-btn').forEach(button => {
//     button.onclick = () => {
//       document.querySelector('.js-article-tag-filter-btn.active').classList.remove('active');
//       button.classList.add('active');
//       let currentTag = button.dataset.tag;
//       console.log(currentTag);
//       document.querySelectorAll('[data-article-tags]').forEach(article => {
//         let articleTagsArray = article.dataset.articleTags.split(',');
//         article.hidden = (!articleTagsArray.includes(currentTag));
//       });
//     }
//   });
// })

function filterArticlesByTag(tag) {
  document.querySelectorAll('.js-article-tag-filter-btn').forEach(button => {
    button.onclick = () => {
      document.querySelector('.js-article-tag-filter-btn.active').classList.remove('active');
      button.classList.add('active');
      let currentTag = button.dataset.tag;
      console.log(currentTag);
      document.querySelectorAll('[data-article-tags]').forEach(article => {
          let articleTagsArray = article.dataset.articleTags.split(',');
          article.hidden = (!articleTagsArray.includes(currentTag));
      });
    }
  });
}

// Function to run the filtering initially
function runArticleFiltering() {
  const activeButton = document.querySelector('.js-article-tag-filter-btn.active');
  const tagToFilter = activeButton ? activeButton.dataset.tag : '';
  filterArticlesByTag(tagToFilter);
}

// Run filtering on document load
document.addEventListener('DOMContentLoaded', runArticleFiltering);
// Run filtering when the window is resized
window.addEventListener('resize', runArticleFiltering);

